import React from 'react';
import PropTypes from 'prop-types';

const setFloorPlanImageVisible = (e, currentUnit, setSelectedFloorPlanUnit, selectedFloorPlanUnit) => {
    setSelectedFloorPlanUnit(!selectedFloorPlanUnit || selectedFloorPlanUnit !== currentUnit ? currentUnit : null);

    e.stopPropagation();
};

export const FloorPlanButton = ({ setSelectedFloorPlanUnit, selectedFloorPlanUnit, unit }) => {
    return (
        <button
            className="button button--utility button--small"
            type="button"
            onClick={e => {
                setFloorPlanImageVisible(e, unit, setSelectedFloorPlanUnit, selectedFloorPlanUnit);
            }}
        >
            {selectedFloorPlanUnit && selectedFloorPlanUnit === unit ? 'Lukk plantegning' : 'Se plantegning'}
        </button>
    );
};

FloorPlanButton.propTypes = {
    setSelectedFloorPlanUnit: PropTypes.func.isRequired,
    selectedFloorPlanUnit: PropTypes.object,
    unit: PropTypes.object,
};
